import React, { useMemo } from 'react';

import styled from 'styled-components';

import { CommunityType } from 'types/communities';

import MapInfoPanelItem from './MapInfoPanelItem';
import { sortCommunitiesByDistance } from './utils';

const Container = styled.div`
  display: flex;
  position: relative;
  padding: 10px;
  overflow: hidden;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  width: 250px;
  padding: 10px 20px;
  overflow: auto;
  gap: 10px;
  border-radius: 10px;
  -webkit-backdrop-filter: blur(27px);
  backdrop-filter: blur(27px);
  background-color: rgba(255, 255, 255, 0.5);
`;

const Title = styled.div`
  font-size: 10px;
  letter-spacing: 2px;
  padding-left: 3px;
  color: var(--text-primary);
`;

const NoCompetitor = styled.div`
  width: 100%;
  height: 200px;
  color: var(--text-secondary);
  font-family: var(--font-bold);
  font-size: 16px;
  text-align: center;
  align-content: center;
`;

type Props = {
  communities: CommunityType[];
  competitors: CommunityType[];
};

const MapInfoPanel = ({ communities, competitors }: Props) => {
  const sortedCompetitors = useMemo(() => sortCommunitiesByDistance(competitors), [competitors]);
  const noCompetitors = sortedCompetitors.length === 0;
  return (
    <Container>
      <Card className="mini-scroll">
        <Title>MY COMMUNITY</Title>
        {communities?.map((community) => <MapInfoPanelItem key={community.id} community={community} />)}
        <Title>COMPETITORS</Title>
        {noCompetitors && <NoCompetitor>No competitors</NoCompetitor>}
        {sortedCompetitors?.map((competitor) => <MapInfoPanelItem key={competitor.id} community={competitor} />)}
      </Card>
    </Container>
  );
};

export default MapInfoPanel;
